/**
 *
 */
const query = (selector, context) => {
  return [].slice.call((context || document).querySelectorAll(selector) || []);
};

export default query;
